import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_ATTRITION_RATE = 0;
const DEFAULT_MAX_ATTRITION_RATE = 25;

export const attritionRateDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.ATTRITION_RATE,
  name: 'Attrition Rate',
  type: FilterType.RANGE,
  min: DEFAULT_MIN_ATTRITION_RATE,
  max: DEFAULT_MAX_ATTRITION_RATE,
  isActive: false,
  isVisible: true,
};

export const attritionRateHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    // Only apply defaults if BOTH min and max are undefined
    // If only one is undefined, keep it undefined (for "greater than" / "less than" filters)
    const shouldApplyDefaults =
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined;

    if (shouldApplyDefaults) {
      return {
        ...currentFilterState,
        min: DEFAULT_MIN_ATTRITION_RATE,
        max: DEFAULT_MAX_ATTRITION_RATE,
      };
    }

    // Preserve the user's selection - don't fill in undefined values
    return currentFilterState;
  },
};
